import styled from "styled-components";

export const Wrap = styled.div`
  width: 100%;
  min-width: 0;
  font-family: Poppins, sans-serif;
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  gap: 12px;
  flex-wrap: wrap;

  h2 {
    margin: 0;
    color: #111;
    font-size: 22px;
    font-weight: 600;
    line-height: 1.2;
  }
`;

export const NewRequestBtn = styled.button`
  background: #ff6b35;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 18px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s;

  &:hover {
    background: #e55a28;
  }
`;

export const SectionTitle = styled.h4`
  margin: 28px 0 12px;
  font-size: 12px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.06em;

  &:first-of-type {
    margin-top: 0;
  }
`;

export const TicketCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  padding: 16px 18px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  margin-bottom: 10px;
  background: #fff;
  cursor: ${(p) => (p.$clickable ? "pointer" : "default")};
  transition: border-color 0.15s, box-shadow 0.15s;

  ${(p) =>
    p.$clickable &&
    `
    &:hover {
      border-color: #ff6b35;
      box-shadow: 0 2px 8px rgba(255, 107, 53, 0.08);
    }
  `}
`;

export const CardBody = styled.div`
  flex: 1;
  min-width: 0;
`;

export const CardRef = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: #111;
  line-height: 1.3;
`;

export const CardMeta = styled.div`
  font-size: 13px;
  color: #6b7280;
  margin-top: 4px;
  line-height: 1.4;
`;

export const CardPreview = styled.div`
  font-size: 13px;
  color: #374151;
  margin-top: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
`;

export const BadgeColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  flex-shrink: 0;
`;

export const StatusPill = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 999px;
  white-space: nowrap;
  line-height: 1.2;
  background: ${(p) => p.$bg || "#f3f4f6"};
  color: ${(p) => p.$color || "#374151"};
  border: 1px solid ${(p) => p.$border || "transparent"};
`;

export const MetaRow = styled.div`
  display: flex;
  gap: 6px;
  margin-top: 8px;
  flex-wrap: wrap;
`;

export const DetailTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #111;
`;

export const DetailDescription = styled.p`
  white-space: pre-wrap;
  color: #374151;
  font-size: 14px;
  line-height: 1.55;
  margin: 12px 0 0;
`;

export const BackLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  padding: 0;
  margin-bottom: 16px;
  color: #ff6b35;
  font-family: inherit;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const Thread = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
`;

export const Bubble = styled.div`
  align-self: ${(p) => (p.$mine ? "flex-end" : "flex-start")};
  max-width: 85%;
  background: ${(p) => (p.$mine ? "#fff3ee" : "#f5f5f5")};
  border-radius: 12px;
  padding: 10px 14px;
  font-size: 14px;
  line-height: 1.45;

  .meta {
    font-size: 11px;
    color: #888;
    margin-bottom: 4px;
  }
`;

export const ReplyBox = styled.div`
  border-top: 1px solid #eee;
  padding-top: 16px;
  margin-top: 8px;
`;

export const AttachGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;

  a {
    font-size: 12px;
    color: #ff6b35;
  }
`;

export const EmptyHint = styled.p`
  color: #9ca3af;
  font-size: 14px;
  margin: 0 0 16px;
`;

export const ReplyActions = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 10px;
  align-items: center;
  flex-wrap: wrap;
`;

export const SendBtn = styled.button`
  background: #ff6b35;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const DetailCard = styled.div`
  background: #fafafa;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px 16px;
  margin: 16px 0;
`;

export const DetailCardTitle = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 10px;
`;

export const MetaDetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
  font-size: 14px;

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }

  span:first-child {
    color: #6b7280;
    flex-shrink: 0;
  }

  span:last-child {
    color: #111;
    text-align: right;
    word-break: break-word;
  }
`;
